<!-- desktop regions selector -->
<div class="w-100 mt0-ns" role="application">
  <div
    class="flex pv3 ph3 nt4 sticky bg-white nl3 nr3 z-max top--2 jb-mobile-top jb-shadow-1-mobile dn-ns"
  >
    <button
      tabindex="0"
      type="button"
      aria-label="back"
      class="back-button bn pointer bg-white medium pa0 pr4"
      (click)="backButtonClick.emit()"
    >
      <jb-expandable-indicator orientation="horizontal" [value]="false">
      </jb-expandable-indicator>
    </button>
    <jb-form-field-container class="dn-ns w-100" type="primary">
      <jb-input-label>{{ label }}</jb-input-label>
      <input
        autofocus
        (focus)="inputFocused.emit()"
        [(ngModel)]="countryName"
        jbInput
        type="text"
        id="text-field-primary"
        (keyup)="filterCountries()"
        #countryField
      />
    </jb-form-field-container>
  </div>
  <div class="w-100 flex flex-column">
    <ng-container *ngIf="!(isMobile$ | async); else regionSelectorContent">
      <jb-tabs
        class="pt3"
        theme="light"
        [isDynamicBase]="true"
        (tabSelected)="tabSelected($event, regionsList)"
        *ngIf="transformedRegions | async | values as regionsList"
        #tabsRef
      >
        <div class="w-100 center">
          <jb-tab-panel
            *ngFor="let region of regionsList; let i = index"
            [label]="region.name"
            [isActive]="region.code === currentRegionCodeInView"
            [iconName]="
              region?.data?.icon?.length ? region?.data?.icon[0].src : undefined
            "
          >
            <ng-container
              *ngTemplateOutlet="regionSelectorContent"
            ></ng-container>
          </jb-tab-panel>
        </div>
      </jb-tabs>
    </ng-container>
  </div>
</div>

<ng-template #regionSelectorContent>
  <div class="w-100 flex flex-column pt4-ns">
    <!-- legend -->
    <div>
      <div *ngIf="isFaresale">
        <button
          type="button"
          (click)="selectAll($event)"
          class="small b royal-blue pointer pv2 ph3 tl"
        >
          {{ content?.citySelector?.faresaleCopy?.viewalldeals }}
        </button>
      </div>
      <!--
        If v2 and mobile. Hide Mint Legend. This legend is not necessary in this case.
        Since this item will be added on each airport in the list.
      -->
      <div *ngIf="!isFaresale" [ngClass]="legendClassNames$ | async">
        <jb-legend
          [filterOutPartner]="filterOutPartner"
          [hideLegend]="hideLegend"
          [customLegendMessage]="customLegendMessage"
          [column]="false"
          [legends]="legends"
        >
        </jb-legend>
      </div>
    </div>

    <!-- content -->
    <div class="w-100 center pl3-ns pt3-ns">
      <div class="pl0 pb3 list pr0 pt0 top-0 region-city-list">
        <p
          *ngIf="!filteredCountriesByRegion?.length"
          class="s-body ph5 lh-copy slate-gray airport-description no-flying-focus"
        >
          {{ noMatchText }}
        </p>

        <!-- mobile view -->
        <ng-container *ngIf="isMobile$ | async">
          <!-- country from/to input empty -->
          <ng-container *ngIf="!countryName">
            <ng-container
              *ngTemplateOutlet="
                !selectListProps.useV2 ? noCountry : useV2SelectListNoCountry;
                context: { groupedAirports: groupedAirports }
              "
            ></ng-container>
          </ng-container>
          <!-- Search result from/to -->
          <div
            *ngIf="
              countryName || (groupedAirports && groupedAirports.length === 0)
            "
          >
            <p
              *ngIf="!filteredAirports.length"
              class="s-body ph5 lh-copy slate-gray airport-description no-flying-focus pt2"
            >
              {{ noMatchText }}
            </p>
            <ng-container
              *ngTemplateOutlet="
                !selectListProps.useV2
                  ? listOptions
                  : useV2SelectListListOptions;
                context: { options: filteredAirports }
              "
            ></ng-container>
          </div>
        </ng-container>

        <!-- desktop view region selector -->
        <ng-container *ngIf="!(isMobile$ | async)">
          <ng-container *ngFor="let country of filteredCountriesByRegion">
            <ul
              *ngIf="country.airports.length"
              [ngClass]="country.airports.length > 10 ? 'db' : 'dib'"
              class="w-100 countries-list list pa0 mb3 f7 royal-blue"
            >
              <li class="w-100 mb1 b tl ttc royal-blue pl3 lh-copy">
                {{ country.name }}
              </li>
              <ng-container *ngFor="let airport of country.airports">
                <li class="w-100 mb1 lh-copy dib">
                  <a
                    #airportName
                    class="h-100 pl3 relative airports-list pointer db no-underline royal-blue"
                    href="javascript:void(0)"
                    (focus)="cityFocused()"
                    (click)="select(airport)"
                  >
                    <span class="absolute left-0 ml1 tc">
                      <ng-container *ngIf="!!legends && legends.length">
                        <ng-container *ngFor="let legend of legends | values">
                          <jb-icon
                            *ngIf="!!legend.image"
                            [label]="legend.image.alt"
                            [hidden]="
                              legend.code.toLowerCase() === 'mint'
                                ? !airport.mint || !airport.jb || hideLegend
                                : legend.code.toLowerCase() === 'partner'
                                ? airport.jb
                                : 'true'
                            "
                            [class]="legend.color"
                            [iconSource]="
                              svgIconService.getSvg(legend.image.src)
                            "
                            width="0.6em"
                            height="0.6em"
                          ></jb-icon>
                        </ng-container>
                      </ng-container>
                    </span>
                    <span class="db">{{ airport.name }}</span>
                  </a>
                </li>
              </ng-container>
            </ul>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #noCountry let-groupedAirports="groupedAirports">
  <ng-container *ngFor="let group of groupedAirports">
    <ul
      *ngIf="group.options.length"
      [ngClass]="group.options.length > 10 ? 'db' : 'dib'"
      class="w-100 countries-list list pa0 mb3 f7 royal-blue"
    >
      <li class="w-100 mb1 b tl ttc royal-blue pl3 lh-copy">
        {{ group.title }}
      </li>
      <ng-container *ngFor="let airport of group.options">
        <li class="w-100 mb1 lh-copy dib">
          <a
            #airportName
            class="h-100 pl3 relative airports-list pointer db no-underline royal-blue w-100"
            href="javascript:void(0)"
            (focus)="cityFocused()"
            (click)="select(airport)"
          >
            <span class="db">{{ airport.name }}</span>
          </a>
        </li>
      </ng-container>
    </ul>
  </ng-container>
</ng-template>

<ng-template #useV2SelectListNoCountry let-groupedAirports="groupedAirports">
  <jb-select-list (selectChange)="select($event.value)">
    <ng-container *ngFor="let group of groupedAirports">
      <jb-select-list-group *ngIf="group.options.length">
        <jb-select-list-group-heading aria-hidden="true">
          <jb-select-list-label>{{ group.title }}</jb-select-list-label>
        </jb-select-list-group-heading>
        <jb-select-list-option
          *ngFor="let airport of group.options"
          [value]="airport"
          [name]="airport.name"
          [secondaryField]="
            airport | dotCountryOrState: selectListProps.cityInSubtext
          "
        >
          <jb-icon
            #primaryIcon
            *ngIf="selectListProps.listIcons"
            [iconSourceUrl]="selectListProps.airportIconSrc"
          ></jb-icon>
          {{
            selectListProps.cityInSubtext
              ? (airport | dotAirportShortName)
              : airport.name
          }}
        </jb-select-list-option>
      </jb-select-list-group>
    </ng-container>
  </jb-select-list>
</ng-template>

<ng-template #listOptions let-options="options">
  <ng-container *ngFor="let option of options">
    <li class="flex ph3 pv2 body royal-blue mr3 list-item">
      <a
        class="flex airports-list pointer no-underline royal-blue w-100"
        href="javascript:void(0)"
        (focus)="cityFocused()"
        (click)="select(option)"
      >
        <span
          [ngSwitch]="!!option.iconName"
          class="pr1"
          [class.pr2]="
            option.iconName !== 'mintIndicator' &&
            option.iconName !== 'partnerAirlineIndicator'
          "
        >
          <div *ngIf="option.iconName === 'mintIndicator'">
            <ng-container
              *ngTemplateOutlet="airportIcon; context: { icon: mintIconLegend }"
            ></ng-container>
          </div>
          <div *ngIf="option.iconName === 'partnerAirlineIndicator'">
            <ng-container
              *ngTemplateOutlet="
                airportIcon;
                context: { icon: partnerIconLegend }
              "
            ></ng-container>
          </div>
          <div *ngSwitchCase="false" class="icon-empty db pr1"></div>
        </span>
        <div
          class="klarheit body royal-blue"
          [class.in-area]="option.pm && !option.cc"
          [innerHtml]="option.name | highlight: countryName"
        ></div>
      </a>
    </li>
  </ng-container>
</ng-template>

<ng-template #airportIcon let-icon="icon">
  <jb-icon
    *ngIf="!!icon.image"
    [label]="icon.image.alt"
    [width]="8"
    [height]="8"
    [iconSource]="svgIconService.getSvg(icon.image.src)"
    [class]="icon.color"
  ></jb-icon>
</ng-template>

<ng-template #useV2SelectListListOptions let-options="options">
  <jb-select-list (selectChange)="select($event.value)">
    <jb-select-list-option
      *ngFor="let airport of options"
      [value]="airport"
      [name]="airport.name"
      [secondaryField]="
        airport | dotCountryOrState: selectListProps.cityInSubtext
      "
      [secondaryIconLabel]="
        airport.iconName
          ? airport.iconName === 'mintIndicator'
            ? getLegendTitle('mint')
            : getLegendTitle('partner')
          : ''
      "
      [indentLevel]="airport.pm && !airport.cc ? 1 : 0"
    >
      <span
        *ngIf="!selectListProps.cityInSubtext"
        [innerHTML]="airport.name | highlight: countryName"
      ></span>
      <span *ngIf="selectListProps.cityInSubtext">{{
        airport | dotAirportShortName
      }}</span>
      <jb-icon
        *ngIf="airport.iconName === 'mintIndicator' && !!mintIconLegend.image"
        id="secondaryIcon"
        #secondaryIcon
        [label]="mintIconLegend.image.alt"
        [width]="8"
        [height]="8"
        [iconSource]="svgIconService.getSvg(mintIconLegend.image.src)"
        [class]="mintIconLegend.color"
      ></jb-icon>
      <jb-icon
        *ngIf="
          airport.iconName === 'partnerAirlineIndicator' &&
          !!partnerIconLegend.image
        "
        id="secondaryIcon"
        #secondaryIcon
        [label]="partnerIconLegend.image.alt"
        [width]="8"
        [height]="8"
        [iconSource]="svgIconService.getSvg(partnerIconLegend.image.src)"
        [class]="partnerIconLegend.color"
      ></jb-icon>
      <jb-icon
        #primaryIcon
        *ngIf="selectListProps.listIcons"
        [iconSourceUrl]="
          airport.cc
            ? selectListProps.destinationIconSrc
            : selectListProps.airportIconSrc
        "
      ></jb-icon>
    </jb-select-list-option>
  </jb-select-list>
</ng-template>
